import type { CareSearchPatientsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

export type PatientListScope = 'default' | 'all';
export type PatientListScopeTab = 'urgent' | 'routine' | 'all';

type DesiredRelationship = NonNullable<CareSearchPatientsRequestT['desired_relationship']>;

export function mapPatientListScopeToDesiredRelationship(
  scope: PatientListScope
): DesiredRelationship {
  switch (scope) {
    case 'default':
      return 'actionable';
    case 'all':
      return 'unlicensed';
    default: {
      const exhaustiveCheck: never = scope;
      return exhaustiveCheck;
    }
  }
}

export function mapPatientListScopeTabToScope(tab: PatientListScopeTab): PatientListScope {
  switch (tab) {
    case 'all':
      return 'all';
    case 'urgent':
    case 'routine':
      return 'default';
    default: {
      const exhaustiveCheck: never = tab;
      return exhaustiveCheck;
    }
  }
}
